import initApps from '../../lib/initApps';

const allApps = [];

$(document).on('turbo:load', () => {
  initApps(allApps);
});
